import { render, staticRenderFns } from "./button.vue?vue&type=template&id=1b3918f5"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3918f5')) {
      api.createRecord('1b3918f5', component.options)
    } else {
      api.reload('1b3918f5', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=1b3918f5", function () {
      api.rerender('1b3918f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/component/button.vue"
export default component.exports